// Utility functions

/**
 * Get the page ID (slug) of the displayed page.
 * ID willbe either the slug defined in the Markdown frontmatter
 *  OR the last element of the URL
 *  OR the sentinel value "index"
 * @returns string
 */
export function getPageId(): string {
  const el = document.querySelector<HTMLElement>("#da-sec-info-root");

  if (el?.dataset.slug) {
    return el.dataset.slug
  }
  console.warn("Missing slug, falling back to the page's URL")
  const pageURL = location.pathname.split("/").filter(Boolean);
  return pageURL[pageURL.length -1] || "index";
  }

/**
 * Determine if a link is to an external site or not
 * @param link
 * @returns boolean
 */
function isExternal(link: HTMLAnchorElement): boolean {
    return link.origin !== window.location.origin;
}

/**
 * Configures links pointing to external pages to open in new tabs / windows.
 * see https://stackoverflow.com/a/4425214/9104474
 * see https://stackoverflow.com/a/15551842/9104474 for reason behind 'noopener noreferrer'
 */
export function openInNewTab(): void {
    document
        .querySelectorAll<HTMLAnchorElement>("a[href]")
        .forEach(link => {
            if (!isExternal(link)) return;

            link.target = "_blank";
            link.rel = "noopener noreferrer";
        });
}

/**
 * Helper function to deterimine if a click should follow a link
 * Used within clickableCards
 * @param event
 * @returns
 */
function shoudlClickOpenLink(event: MouseEvent): boolean  {
  const selection = window.getSelection();
  if (selection?.toString().trim()) {
    console.debug('Click ignored — text selection detected');
    return false;
  }

  // Ignore clicks on interactive elements within the card
  const target = event.target;
  if (
    target instanceof Element &&
    target.closest("a, button, input, select, textarea")
  ) {
    console.debug(`Click ignored - interactive element: $target}`)
    return false
  }

  return true
}

/**
 * Helper function for finding a card link
 * @param card li element
 * @returns
 */
function getCardLink(card: HTMLLIElement): HTMLAnchorElement | null {
  return card.querySelector<HTMLAnchorElement>("a");
}

/**
 * Updates Zeniscal Cards to become clickable with the link that is defined therein.
 */
export function clickableCards(): void {

  const cards = document.querySelectorAll<HTMLLIElement>(" .cards li");
  cards.forEach(card => {
    card.addEventListener("click", event  => {
      // should click open link?
      if (!shoudlClickOpenLink(event)) return;
      const link = getCardLink(card);
      // if no link found
      if (!link) return;
      // otherwise open link
      window.open(
        link.href,
        link.target || "_self"
      );

    });
  });
}

export const ROOT_PAGE_SLUG = "overview"

export function isOverviewPage(): boolean {
  const daSecInfoRoot = document.getElementById("da-sec-info-root");
  const slug = daSecInfoRoot?.getAttribute("data-slug");
   // console.debug("slug:", slug)
  if (slug === ROOT_PAGE_SLUG) {
    return true;
  }
  return false;
}
